// extracted by mini-css-extract-plugin
export default {"headerContainer":"HeaderViewer-module__headerContainer--p0Eo1","minimalHeader":"HeaderViewer-module__minimalHeader--jTSpm"};